import { MaintenancePlan } from "hooks/useMaintenancePlan";

export const MAINTENANCE_PRICE_IDS: Record<MaintenancePlan, string> = {
    core: "SCMAMO5",
    plus: "SPMAMO5"
};
